export const blogArticles = [
  {
    id: 1,
    slug: 'gerer-stress-travail-lubumbashi',
    title: 'Comment gérer le stress au travail à Lubumbashi',
    excerpt: 'Découvrez des techniques efficaces pour réduire le stress professionnel et améliorer votre bien-être au quotidien dans le contexte de Lubumbashi.',
    content: 'Le stress au travail est un défi majeur pour de nombreux professionnels à Lubumbashi. Dans cet article, nous explorons des stratégies pratiques adaptées à notre contexte local...',
    category: 'Bien-être au travail',
    author: 'Dr. Sarah Mukendi',
    date: '2025-01-15',
    readTime: '5 min',
    image: 'https://public.readdy.ai/ai/img_res/c0a869c1c16b66e8f9f087be6a26cce9.jpg',
    tags: ['stress', 'travail', 'bien-être', 'Lubumbashi']
  },
  {
    id: 2,
    slug: 'bienfaits-massage-prenatal-grossesse',
    title: 'Les bienfaits du massage prénatal pendant la grossesse',
    excerpt: 'Le massage prénatal offre de nombreux avantages pour les futures mamans. Découvrez comment il peut améliorer votre confort pendant la grossesse.',
    content: 'La grossesse est une période merveilleuse mais aussi exigeante pour le corps. Le massage prénatal est une solution naturelle pour soulager les inconforts...',
    category: 'Maternité',
    author: 'Marie Kabila',
    date: '2025-01-10',
    readTime: '6 min',
    image: 'https://readdy.ai/api/search-image?query=gentle%20prenatal%20massage%20for%20pregnant%20woman%2C%20maternal%20wellness%2C%20pregnancy%20care%2C%20peaceful%20spa%20environment%2C%20soft%20pink%20tones%2C%20professional%20healthcare%20setting&width=800&height=500&seq=blog2&orientation=landscape',
    tags: ['grossesse', 'massage', 'maternité', 'santé']
  },
  {
    id: 3,
    slug: 'nutrition-energie-vitalite-rdc',
    title: 'Nutrition et énergie : aliments pour booster votre vitalité en RDC',
    excerpt: 'Découvrez les aliments locaux riches en nutriments qui peuvent augmenter votre énergie et renforcer votre système immunitaire.',
    content: 'Une alimentation équilibrée est la clé d\'une énergie durable. En RDC, nous avons accès à de nombreux aliments nutritifs locaux...',
    category: 'Nutrition',
    author: 'Dr. Jean Kalombo',
    date: '2025-01-05',
    readTime: '7 min',
    image: 'https://readdy.ai/api/search-image?query=colorful%20fresh%20local%20african%20foods%20and%20vegetables%2C%20nutritious%20meal%20preparation%2C%20healthy%20eating%2C%20vibrant%20produce%2C%20clean%20white%20background%2C%20food%20photography&width=800&height=500&seq=blog3&orientation=landscape',
    tags: ['nutrition', 'énergie', 'alimentation', 'santé']
  },
  {
    id: 4,
    slug: 'sante-mentale-importance-soutien-psychologique',
    title: 'Santé mentale : l\'importance du soutien psychologique',
    excerpt: 'La santé mentale est aussi importante que la santé physique. Apprenez pourquoi consulter un psychologue peut transformer votre vie.',
    content: 'Dans notre société, parler de santé mentale reste parfois tabou. Pourtant, prendre soin de son bien-être psychologique est essentiel...',
    category: 'Santé mentale',
    author: 'Dr. Chantal Mbuyi',
    date: '2024-12-28',
    readTime: '8 min',
    image: 'https://readdy.ai/api/search-image?query=mental%20health%20support%20and%20psychological%20counseling%2C%20therapeutic%20conversation%2C%20emotional%20wellness%2C%20calm%20peaceful%20atmosphere%2C%20professional%20healthcare%20setting%2C%20soft%20natural%20lighting&width=800&height=500&seq=blog4&orientation=landscape',
    tags: ['santé mentale', 'psychologie', 'bien-être', 'soutien']
  },
  {
    id: 5,
    slug: 'technologie-vr-massage-innovation-lubumbashi',
    title: 'Technologie VR Massage : l\'innovation bien-être arrive à Lubumbashi',
    excerpt: 'HMC CLINIC introduit la technologie VR Massage en RDC. Découvrez cette expérience immersive unique qui révolutionne la relaxation.',
    content: 'La réalité virtuelle n\'est plus réservée aux jeux vidéo. À HMC CLINIC, nous l\'utilisons pour créer des expériences de relaxation profonde...',
    category: 'Innovation',
    author: 'Patrick Mwanza',
    date: '2024-12-20',
    readTime: '5 min',
    image: 'https://readdy.ai/api/search-image?query=virtual%20reality%20massage%20technology%20in%20modern%20wellness%20clinic%2C%20innovative%20healthcare%2C%20VR%20headset%20during%20therapy%2C%20futuristic%20medical%20spa%2C%20blue%20ambient%20lighting%2C%20high-tech%20environment&width=800&height=500&seq=blog5&orientation=landscape',
    tags: ['technologie', 'VR', 'innovation', 'massage']
  },
  {
    id: 6,
    slug: 'exercices-relaxation-quotidien',
    title: '5 exercices de relaxation à pratiquer au quotidien',
    excerpt: 'Des techniques simples et efficaces pour vous détendre en quelques minutes, où que vous soyez.',
    content: 'La relaxation ne nécessite pas toujours une séance en clinique. Voici cinq exercices que vous pouvez pratiquer chez vous ou au bureau...',
    category: 'Bien-être',
    author: 'Sophie Tshimanga',
    date: '2024-12-15',
    readTime: '4 min',
    image: 'https://readdy.ai/api/search-image?query=person%20practicing%20relaxation%20exercises%20at%20home%2C%20meditation%20and%20breathing%20techniques%2C%20peaceful%20calm%20atmosphere%2C%20natural%20lighting%2C%20wellness%20lifestyle%2C%20clean%20minimalist%20setting&width=800&height=500&seq=blog6&orientation=landscape',
    tags: ['relaxation', 'exercices', 'bien-être', 'quotidien']
  }
];